import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { AppContext } from '@prisjakt/ui-app-context';

import { Video, VideoThumbnail } from 'src/components/carousel';
import Lightbox from 'src/components/lightbox';

import { productMediaSetPosition } from '../../actions/media';

import { trackProductMediaViewed } from '../product-media/tracking';

import { Media } from '../product-media/types';

type Props = {
  close: () => void;
  media: Media;
  position?: number;
};

const ProductMediaLightbox = (props: Props) => {
  const { close, media, position = 0 } = props;

  const { t } = useContext(AppContext);

  const dispatch = useDispatch();

  const { videos, images, large: largeImages } = media;

  // Tracking: fired initially when image with index 0 is in view
  useEffect(() => {
    trackProductMediaViewed({ index: 0 });
  }, []);

  const thumbnails = [
    ...(images || []),
    ...(videos
      ? videos
          .map(video =>
            video.thumbnail ? (
              <VideoThumbnail key={video.source_id} src={video.thumbnail} />
            ) : null
          )
          .filter(item => item)
      : []),
  ];

  const items = [
    ...(largeImages
      ? largeImages.map(src => <img key={src} src={src} alt="" />)
      : []),
    ...(videos
      ? videos
          .map(video =>
            video.embed_url ? (
              <Video key={video.source_id} src={video.embed_url}>
                <p>{t('product', 'video.brand-disclaimer')}</p>
              </Video>
            ) : null
          )
          .filter(item => item)
      : []),
  ];

  return (
    <Lightbox
      items={items}
      thumbnails={thumbnails}
      position={position}
      close={close}
      onChange={(index: number, type: string) => {
        dispatch(productMediaSetPosition(index, { action: type }));
        trackProductMediaViewed({ index });
      }}
      isOpen
    />
  );
};

export default ProductMediaLightbox;
